import { Heading } from './Heading';
import { Stack } from './Stack';
import { Text } from './Text';

/** Props for {@link EmptyState}. */
export interface EmptyStateProps {
  /** What is missing. */
  readonly title: string;
  /** Why it is missing, and what to do about it. */
  readonly description?: string;
  /** The action that resolves the emptiness. */
  readonly action?: React.ReactNode;
}

/**
 * Shown when a view has loaded successfully and has nothing to show.
 *
 * Distinct from {@link ErrorState} on purpose: "you have no vehicles yet" and "we could not load
 * your vehicles" demand completely different responses from the reader, and conflating them is one
 * of the most common ways an interface misleads.
 *
 * @param props - Component props.
 * @returns The empty state element.
 */
export function EmptyState({ title, description, action }: EmptyStateProps): React.JSX.Element {
  return (
    <div className="gm-state">
      <Stack gap="md" align="center">
        <Heading level={3}>{title}</Heading>
        {description !== undefined && <Text muted>{description}</Text>}
        {action}
      </Stack>
    </div>
  );
}
